//Imports node_modules
import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'

//Imports Css
import './App.css'

//Imports Components
import Content from '../content/Content'

//Imports Data
import GlobalVariables from '../data/GlobalVariables'
import GlobalFunctions from '../data/GlobalFunctions'
import GlobalModals from '../data/GlobalModals'
import GlobalForms from '../data/GlobalForms'
import AxiosCalls from '../data/AxiosCalls'

//Import Modals
import MessageModal from '../components/Global/modals/Message/MessageModal'
import FormModal from '../components/Global/modals/Form/FormModal'
import LoadingModal from '../components/Global/modals/loadingModal/LoadingModal'

//Main theme, importado do skote dashboard

const App = props => {

    // react Hook For State Handler
    const [data, setData] = useState(null)


    useEffect(() => {
        // Fetch Function   
        fetch("data/taiConfig.json").then(
            function (res) {
                return res.json()
            }).then(function (data) {
                //Url de conecção á api
                if (data.SERVER_URL === '') {
                    console.log('Precisa de configurar a ligação á api')
                }
                setData(data)
            }).catch(
                function (err) {
                    console.log(err, ' error')
                }
            )
        // eslint-disable-next-line
    }, [])

    return (
        <div className="App">
            {
                // use data State Variable For Get Data Use JavaScript Map Mathod
                data ?
                    <Router baseName='/'>
                        <GlobalVariables serverData={data}>
                            <GlobalModals>
                                <GlobalFunctions>
                                    <GlobalForms>
                                        <AxiosCalls>
                                            <div className="App">
                                                {/* Dependendo do url ele muda de página */}
                                                <Content />

                                                {/* Modals */}
                                                <MessageModal></MessageModal>
                                                <FormModal></FormModal>
                                                <LoadingModal></LoadingModal>
                                            </div>
                                        </AxiosCalls>
                                    </GlobalForms>
                                </GlobalFunctions>
                            </GlobalModals>
                        </GlobalVariables>
                    </Router>
                    :
                    ""
            }
        </div>
    )
}
export default App

